<p-autoComplete
  #autocomplete
  [disabled]="disabled()"
  [suggestions]="instances()"
  [minLength]="1"
  [showEmptyMessage]="false"
  [autoHighlight]="true"
  [placeholder]="placeholder()"
  (onFocus)="showAutocompleteOptions($event)"
  (onClear)="showAutocompleteOptions($event)"
  (completeMethod)="onSearch($event.query)"
  (ngModelChange)="setInstance($event)"
  [(ngModel)]="instanceModel"
  class="flx-prime-autocomplete small"
  panelStyleClass="flx-prime-autocomplete small"
  optionLabel="uuid"
  appendTo="body"
>
  <ng-template
    let-instance
    pTemplate="item"
  >
    <div class="w-full flex justify-between items-center gap-5">
      <span class="font-bold font-mono">{{ instance.uuid }}</span>
      <p-tag
        [value]="instance.statusLabel"
        [severity]="instance.statusSeverity"
        class="flx-tag"
        styleClass="text-2xs px-1 text-nowrap"
      ></p-tag>
      <span
        [innerHTML]="instance.dateStarted | flxTableDateFormat"
        class="w-36"
      ></span>
    </div>
  </ng-template>
</p-autoComplete>
